import { useFormik } from "formik";
import { Button, Grid2, Stack, Typography } from "@mui/material";
import { toast } from "react-toastify";

import Logo from "../assets/svg/logo-full.svg";
import { Input } from "../components/Input";
import { useState } from "react";
import OtpInput from "react-otp-input";
import { useMutation } from "@tanstack/react-query";
import {
  forgotPassWord,
  updatePassByToken,
  validateToken,
} from "../services/auth";
import { useNavigate } from "react-router-dom";
import { formatPhone, unMask } from "../helpers/format";
import ContainerLoadingLogin from "../components/ContainerLoadingLogin";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [otp, setOtp] = useState("");

  const { mutate, isPending } = useMutation({
    mutationFn: forgotPassWord,
    onSuccess: () => {
      toast.success("Enviamos um WhatsApp para seu número!");
      setStep(step + 1);
    },
    onError: (e: { response: { data: { message: string } } }) => {
      toast.error(String(e?.response?.data?.message) || "Erro!");
    },
  });

  const { mutate: mutateToken, isPending: isPendingToken } = useMutation({
    mutationFn: async () => await validateToken({ token: otp }),
    onSuccess: () => {
      setStep(step + 1);
    },
    onError: (e: { response: { data: { message: string } } }) => {
      toast.error(String(e?.response?.data?.message) || "Erro!");
    },
  });

  const { mutate: mutatePassword, isPending: isPendingPassword } = useMutation({
    mutationFn: async () =>
      await updatePassByToken({ token: otp, password: values.password }),
    onSuccess: () => {
      toast.success("Senha alterada com sucesso!");
      navigate("/");
    },
    onError: (e: { response: { data: { message: string } } }) => {
      toast.error(String(e?.response?.data?.message) || "Erro!");
    },
  });

  const { handleChange, values, handleSubmit } = useFormik({
    initialValues: {
      phone: "",
      confirm: "",
      password: "",
    },
    onSubmit: (values) => {
      mutate({
        phone: unMask(values.phone),
      });
    },
  });

  return (
    <ContainerLoadingLogin
      loading={isPending || isPendingToken || isPendingPassword}
    >
      <Grid2 container sx={styles.container}>
        {step === 1 && (
          <Grid2 container sx={styles.paper} spacing={4}>
            <Grid2 size={12}>
              <img src={Logo} alt="" />
            </Grid2>{" "}
            <Grid2 size={12}>
              <Typography variant="h4" fontWeight={700}>
                Redefinir Senha
              </Typography>
              <Typography>
                Enviaremos um SMS com o link de redefinição de senha para o seu
                celular
              </Typography>
            </Grid2>
            <Grid2 container spacing={2} size={12}>
              <Grid2 size={12}>
                <Input
                  id="phone"
                  name="phone"
                  label="Telefone"
                  type="tel"
                  fullWidth
                  value={formatPhone(values.phone)}
                  onChange={handleChange}
                />
              </Grid2>
              <Grid2 size={12} mt={1}>
                <Button
                  fullWidth
                  size="large"
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    if (!values.phone) {
                      toast.error("Digite seu telefone");
                      return;
                    }
                    handleSubmit();
                  }}
                >
                  Enviar SMS
                </Button>
              </Grid2>
            </Grid2>
          </Grid2>
        )}
        {step === 2 && (
          <Grid2 container sx={styles.paper} spacing={4}>
            <Grid2 size={12}>
              <img src={Logo} alt="logo" />
            </Grid2>
            <Grid2 size={12}>
              <Typography variant="h4" fontWeight={700}>
                Redefinir Senha
              </Typography>
              <Typography>
                Informe o código enviado para o seu e-mail para cadastrar uma
                nova senha.
              </Typography>
            </Grid2>
            <Grid2 size={12}>
              <Stack spacing={4} alignItems="center">
                <Typography fontWeight={700}>
                  Informe o token que você recebeu
                </Typography>
                <OtpInput
                  value={otp}
                  onChange={setOtp}
                  numInputs={5}
                  renderInput={(props) => <input {...props} />}
                  containerStyle={{ gap: 10 }}
                  inputStyle={{
                    height: "60px",
                    width: "50px",
                    fontSize: "32px",
                    fontWeight: 600,
                    color: "primary.contrastText",
                    backgroundColor: "secondary.light",
                    borderRadius: "10px",
                    borderStyle: "solid",
                    borderColor: "secondary.contrastext",
                  }}
                />
                <Button
                  variant="contained"
                  sx={{ width: "82%" }}
                  size="large"
                  color="primary"
                  onClick={() => {
                    if (!otp) {
                      toast.error("Digite o token!");
                      return;
                    }
                    mutateToken();
                  }}
                >
                  Confirmar
                </Button>
              </Stack>
            </Grid2>
          </Grid2>
        )}
        {step === 3 && (
          <Grid2 container sx={styles.paper} spacing={4}>
            <Grid2 size={12}>
              <img src={Logo} alt="" />
            </Grid2>{" "}
            <Grid2 size={12}>
              <Typography variant="h4" fontWeight={700}>
                Redefinir Senha
              </Typography>
              <Typography>Digite e confirme a sua nova senha.</Typography>
            </Grid2>
            <Grid2 container spacing={2} size={12}>
              <Grid2 size={12}>
                <Input
                  id="password"
                  name="password"
                  label="Nova senha"
                  type="password"
                  fullWidth
                  value={values.password}
                  onChange={handleChange}
                />
              </Grid2>
              <Grid2 size={12}>
                <Input
                  id="confirm"
                  name="confirm"
                  label="Confirme a nova senha"
                  type="password"
                  fullWidth
                  value={values.confirm}
                  onChange={handleChange}
                />
              </Grid2>
            </Grid2>
            <Grid2 size={12}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                size="large"
                onClick={() => {
                  if (!values.password) {
                    toast.error("Digite sua nova senha");
                    return;
                  }
                  if (!values.confirm) {
                    toast.error("Confirme sua nova senha");
                    return;
                  }

                  if (values.password !== values.confirm) {
                    toast.error("Senhas não conferem!");
                    return;
                  }

                  mutatePassword();
                }}
              >
                Alterar senha
              </Button>
            </Grid2>
          </Grid2>
        )}
      </Grid2>
    </ContainerLoadingLogin>
  );
};

const styles = {
  paper: {
    width: { md: "40%" },
    backgroundColor: "background.default",
    padding: "2rem",
    borderRadius: "24px",
  },
  avatar: {
    backgroundColor: "blueviolet",
  },

  container: {
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
  },
};

export default ForgotPassword;
